<template>
  <div class="container-fluid mt-4">
    <div class="d-flex flex-column justify-content-center mb-4">
      <span class="welcome mt-5">
        welcome to your custom form settings
      </span>
      <span class="welcome-subheading mt-3">
        You can create a custom form and copy the code into your website. New leads will come directly into mod24 dispatch app.
        <br />
        Choose one of the options below.
      </span>
    </div>
    <div class="d-flex justify-content-around align-items-center mt-5">
      <div class="form-style-box" @click="type = 'custom'" :class="[type === 'custom' ? 'selected' : '']">
        <div class="form-style-name mb-1">
          Custom form
        </div>
        <div class="form-style-subheading mt-3">
          Choose this option if you want to create your own form. We will provide you with the necessary information how to submit it.
        </div>
        <div class="form-style-list mt-2">
          <ul>
            <li>
              Your own style
            </li>
          </ul>
        </div>
      </div>
      <div class="form-style-box" @click="type = 'editing'" :class="[type === 'editing' ? 'selected' : '']">
        <div class="form-style-name mb-1">
          Simple button
        </div>
        <div class="form-style-subheading mt-3 mb-3">
          Choose this option if you just want a simple button that will open a modal or pop-up form.
        </div>
        <div class="form-style-list mt-2">
          <ul>
            <li>
              Customisable button style
            </li>
            <li>
              Simple to add to your HTML app
            </li>
            <li>
              Predefined form pop-up or modal
            </li>
          </ul>
        </div>
      </div>
      <div class="form-style-box" @click="type = 'iframe'" :class="[type === 'iframe' ? 'selected' : '']">
        <div class="form-style-name mb-1">
          Iframe form
        </div>
        <div class="form-style-subheading mt-3">
          Choose this option if you want to embed a form on your website.
        </div>
        <div class="form-style-list mt-2">
          <ul>
            <li>
              Simple
            </li>
            <li>
              Connected to your company on mod24
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="w-100 mt-5 mr-3 text-center">
      <span class="text-danger">Web key: {{ company.web_key }}</span>
    </div>
    <div class="d-flex flex-column align-items-center mt-5" v-if="type.length">
      <button class="btn btn-primary text-uppercase proceed-button" @click="proceed">
        proceed to web quote settings
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    company: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    type: '',
  }),
  methods: {
    proceed() {
      if (this.type === 'editing') {
        this.$emit('setStepEditing');
      } else if (this.type === 'custom') {
        this.$emit('setStepCustom');
      } else {
        this.$emit('setStepIframe');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
li {
  font-size: 11px;
  color: #808d98;
}
.welcome {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  color: #616161;
}
.welcome-subheading {
  font-size: 11px;
  text-align: center;
  color: #808d98;
}
.form-style-box {
  background: #ffffff;
  border: 1px solid #ececec;
  border-radius: 3px;
  min-width: 240px;
  min-height: 230px;
  cursor: pointer;
  padding: 16px;
  max-width: 240px;
}
.form-style-name {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  text-align: start;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  color: #616161;
}
.form-style-subheading {
  font-size: 11px;
  text-align: start;
  color: #808d98;
  word-break: break-word;
}
.selected {
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.25);
  border: 1px solid #2962ff;
}
.proceed-button {
  width: 361px;
  min-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/companies/CompaniesWebQuoteSelect.vue